import React from "react";
import Image from "next/image";

const PoolInfoCard = ({ title, poolType, width, length, depth }) => {
  return (
    <div className="flex flex-col rounded-[10px] bg-[#F3F6FA] px-5 pt-6 pb-[18px]">
      <div className="flex flex-col mb-4">
        <span
          className={`text-themeBlack text-sm font-semibold leading-normal`}
        >
          {title}
        </span>
      </div>
      {poolType !== "Yok" ? (
        <div>
          <div className="flex flex-col gap-[14px] border-b border-[#DCE2E9] pb-4 mb-4">
            <div className="flex">
              <div className="w-2/3">
                <span className="text-sm text-themeBlack text-opacity-70">
                  Derinlik
                </span>
              </div>
              <div className="w-1/3">
                <span className="text-sm text-themeBlack text-opacity-70">
                  {depth || "Yok"}
                </span>
              </div>
            </div>
            <div className="flex">
              <div className="w-2/3">
                <span className="text-sm text-themeBlack text-opacity-70">
                  En
                </span>
              </div>
              <div className="w-1/3">
                <span className="text-sm text-themeBlack text-opacity-70">
                  {width || "Yok"}
                </span>
              </div>
            </div>
            <div className="flex">
              <div className="w-2/3">
                <span className="text-sm text-themeBlack text-opacity-70">
                  Boy
                </span>
              </div>
              <div className="w-1/3">
                <span className="text-sm text-themeBlack text-opacity-70">
                  {length || "Yok"}
                </span>
              </div>
            </div>
          </div>
          {title === "Kapalı Havuz" ? (
            <div className="flex">
              <div className="w-1/3">
                <span className="text-sm font-normal leading-normal text-themeBlack text-opacity-70">
                  Isıtma
                </span>
              </div>
              <div className="w-2/3">
                <span className="text-sm font-normal leading-normal text-themeBlack text-opacity-70">
                  {/* {heating} */}
                </span>
              </div>
            </div>
          ) : poolType !== "Yok" ? (
            <span className="text-sm font-normal leading-normal text-themeBlack text-opacity-70">
              Isıtma bulunmamaktadır
            </span>
          ) : null}
        </div>
      ) : (
        <div className="flex items-end h-full">
          <div className="flex items-center gap-2.5">
            <Image
              src="/icons/depositTest.svg"
              width={42}
              height={42}
              alt={title}
              className="object-contain"
            />
            <span className="text-sm font-semibold leading-normal text-opacity-50 text-themeBlack">
              bulunmuyor
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PoolInfoCard;
